import React ,{useState , useCallback} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {NavLink,Link} from 'react-router-dom';
import { useSwipeable} from 'react-swipeable'
import {url} from '../resapi'
export const slideColorContext = React.createContext("")


const Slide = (props)=> {
  const [section,setSection] = useState(0);
  const [isEnableArrow,setIsEnableArrow] = useState(true);
  const [isStateClick,setStateClick] = useState("left")
  const handelSelectCard = useCallback(() => {
    const items = props.data.image.map((data,key) => (
      key===section?
      <img key={key}
           src={`${url}/${data.img}`} 
           alt="title"
           style={{objectFit: data.fit,padding:data.fit==="cover"?"0" : "12.5vh 6.6vw"}}
      />
      :""
    ));
    return items
  },[props,section])
  const config = {
        delta: 10,                           
        preventDefaultTouchmoveEvent: false,   
        trackTouch: true,                      
        trackMouse: false,                    
        rotationAngle: 0, 
  }
  const handlers = useSwipeable({ onSwipedLeft: () => handleChange("right"),onSwipedRight:() => handleChange("left"), ...config })
  const handleChange = useCallback(async (value) => {
  if(isEnableArrow){
    await setIsEnableArrow(false)
      if(value==="left"){
        if(section!==0){
          if(props.data.image[section].fit==="cover" && props.data.image[section-1].fit==="cover"){
            setStateClick("left-static")
          }else {
            setStateClick("left")
          }
          await setSection(section-1)
          await props.setColor(props.data.image[section-1].color)
        } 
        else {
          if(props.data.image[section].fit==="cover" && props.data.image[props.data.image.length-1].fit==="cover"){
            setStateClick("left-static")
          }else {
            setStateClick("left")
          }
          await setSection(props.data.image.length-1)
          await props.setColor(props.data.image[props.data.image.length-1].color)
        }
      }
      else {
        if((props.data.image.length-1)!==section){
          if(props.data.image[section].fit==="cover" && props.data.image[section+1].fit==="cover"){
            setStateClick("right-static")
          }else {
            setStateClick("right")
          }
          await setSection(section+1)
          await props.setColor(props.data.image[section+1].color)
        } 
        else {
          if(props.data.image[section].fit==="cover" && props.data.image[0].fit==="cover"){
            setStateClick("right-static")
          }else {
            setStateClick("right")
          }
          await setSection(0)
          await props.setColor(props.data.image[0].color)
        }
      }
    
    await setTimeout(() => {
      setIsEnableArrow(true)
    }, 1250);
  }
  },[props,section,isEnableArrow])
  return (
    <React.Fragment>
    <div className="slide-work" style={{backgroundColor:props.data.image[section].bg,color:props.data.image[section].color,height:window.innerWidth<window.innerHeight?"60vmin":"100vmin"}}>
    {parseInt(props.index)===0?
          <div className="projectsection sectionheader" style={{color:props.data.image[section].color}}>
            <NavLink to="/" className="clickable" style={{color:"inherit"}}>home</NavLink>
            <NavLink to={`/${props.route.pagename}`} className="clickable" style={{color:"inherit"}}>{props.route.pagename}</NavLink>
            <Link to={{
                  pathname: `/${props.route.pagename}/${props.route.params}`,
                  }}
                  style={{color:"inherit"}} className="clickable">{props.route.name}</Link>
        </div>:""}

        <div className="images" {...handlers}>
        {props.data.image.length>0?
        <ReactCSSTransitionGroup
            transitionName={`work-slide-project-${isStateClick}`}
            // transitionAppear={true}
            // transitionAppearTimeout={1400}
            transitionEnter={true}
            transitionLeave={true}
            transitionEnterTimeout={1200}
            transitionLeaveTimeout={1200}>
            {handelSelectCard()}
        </ReactCSSTransitionGroup>
        :""}
        </div>
        {props.data.image.length<=1?
        ""
        :
        <div className="arrow">
        <span className="left clickable" onClick={()=>handleChange("left")}><i className="icon icon-arrow-left"></i></span>
        <span className="clickable" onClick={()=>handleChange("right")}><i className="icon icon-arrow-right"></i></span>
        </div>
        }
        {parseFloat(props.index)===0?
        <div className="footer">
          <div className="summary">
          {props.subData.flag && <span><img src={`${url}/${props.subData.flag}`} alt="flag"/></span>}
          {props.subData.country && <span>{props.subData.country}</span>}
          {props.subData.colorPalette.length>0 &&<span>Color palette</span>}
          {props.subData.colorPalette.length>0 && <span>
              {props.subData.colorPalette.map((data,key)=>
                <span key={key} style={{backgroundColor:data}}></span>
              )}
            </span>}
          </div>
          <div className="center">
            <div style={{backgroundColor:props.data.image[section].color==="#000"?"rgba(0,0,0,0.4)":"rgba(255,255,255,0.4)"}}>
              <span style={{backgroundColor:props.data.image[section].color==="#000"?"rgba(255,255,255,0.4)":"rgba(0,0,0,0.4)"}}></span>
            </div>  
          </div>
          <div></div>
        </div>
        :""}
    </div>
    </React.Fragment>
  );
}

export default Slide;